module.exports = __webpack_public_path__ + "static/img/CgoRC2REgyyAMxFsAARZ8Yu1vjg627.f60c725.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2REgyyAMxFsAARZ8Yu1vjg627.jpg
// module id = 8ia0
// module chunks = 73